const DEFAULT_BRAND = 'ford'

export function getLogoBrand() {
  return process.env.VUE_APP_LOGO_BRAND || DEFAULT_BRAND
}

function requireBrandLogo(suffix) {
  const brand = getLogoBrand()
  // eslint-disable-next-line import/no-dynamic-require, global-require
  return require(`@/assets/images/logo/${brand}-${suffix}.png`)
}

export const brandLogo = requireBrandLogo('logo')
export const brandLogoMobile = requireBrandLogo('logo-mobile')
